import Table from '@/components/Table/Table';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import TrashIcon from '@/assets/trash.svg?react';
import { GameSchema } from '@/lib/types';
import TableActions from './TableActions';
import { ColumnDef, Order } from '@/components/Table/TableHelpers';
import GamesFilters from './GamesFilters';
import { FilterSchema } from '@/components/ResourcesSidebar/ResourcesSidebarHelpers';
import Rtp from '@/components/Rtp/Rtp';

const GamesTable = ({
  games,
  searchText,
  filters,
  onSearchTextChange,
  onFiltersChange,
  order,
  orderBy,
  onRequestSort,
  loading = false,
}: {
  games: GameSchema[];
  searchText: string;
  filters: Partial<FilterSchema>;
  onFiltersChange: (filters: Partial<FilterSchema>) => void;
  onSearchTextChange: (text: string) => void;
  order: Order;
  orderBy: keyof GameSchema;
  onRequestSort: (property: keyof GameSchema) => void;
  loading?: boolean;
}) => {
  const columns: ColumnDef<GameSchema>[] = [
    {
      field: 'game_name',
      label: 'Game Name',
      width: '35%',
    },
    {
      field: 'rtp',
      label: 'RTP',
      render: (row) => <Rtp value={row.rtp} />,
    },
    { field: 'status', label: 'Status' },
    {
      id: 'actions',
      label: 'Delete',
      sortable: false,
      render: (row) => (
        <IconButton
          onClick={() => {
            console.log('Delete', row.id);
          }}
        >
          <TrashIcon />
        </IconButton>
      ),
      align: 'right',
    },
  ];

  const filteredGames = games.filter((game) =>
    game.game_name.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <>
      <TableActions
        searchText={searchText}
        onSearchTextChange={onSearchTextChange}
        filters={
          <GamesFilters
            filters={filters}
            onFiltersChange={onFiltersChange}
          />
        }
        filtersValues={filters}
      />
      <StyledTable
        loading={loading}
        rows={filteredGames || []}
        columns={columns}
        order={order}
        orderBy={orderBy}
        onRequestSort={onRequestSort}
      />
    </>
  );
};

const StyledTable = styled(Table<GameSchema>)({
  padding: '0 40px',
});

export default GamesTable;
